import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path
      fill="#C7D0D9"
      d="M79.33 106.67c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6m0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4"
    />
    <path fill="#ACB8C3" d="M71.23 17.02a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#C7D0D9"
      d="M112.07 73.44a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M20.67 108.67c-.38 0-.77-.15-1.06-.44a1.49 1.49 0 0 1 0-2.12l9.99-9.99a1.49 1.49 0 0 1 2.12 0c.58.59.59 1.54 0 2.12l-9.99 9.99c-.29.29-.68.44-1.06.44"
    />
    <path
      fill="#C7D0D9"
      d="M30.66 108.67c-.38 0-.77-.15-1.06-.44l-9.99-9.99a1.49 1.49 0 0 1 0-2.12c.59-.58 1.54-.59 2.12 0l9.99 9.99c.59.59.59 1.54 0 2.12-.29.29-.68.44-1.06.44M104.57 37.13c-.83 0-1.5-.67-1.5-1.5V21.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v14.13c0 .83-.67 1.5-1.5 1.5"
    />
    <path
      fill="#C7D0D9"
      d="M111.63 30.06H97.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h14.13c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M99.41 103.07a4.2 4.2 0 0 1-3-1.25L77.73 83.14a4.249 4.249 0 1 1 6.01-6.01l18.68 18.68a4.25 4.25 0 0 1 0 6.01c-.83.83-1.92 1.25-3 1.25z"
    />
    <path
      fill="#ACB8C3"
      d="M57.93 89.58c17.905 0 32.42-14.515 32.42-32.42S75.835 24.74 57.93 24.74 25.51 39.255 25.51 57.16s14.515 32.42 32.42 32.42"
    />
    <path
      fill="#C7D0D9"
      d="M57.88 82.47c13.978 0 25.31-11.332 25.31-25.31 0-13.979-11.332-25.31-25.31-25.31S32.57 43.18 32.57 57.16s11.332 25.31 25.31 25.31"
    />
    <path
      fill="#8F9BA8"
      d="M83.17 56.37c-.23-7.41-3.64-14.01-8.91-18.49-3.57 1.61-6.06 5.19-6.06 9.36 0 5.67 4.6 10.27 10.27 10.27 1.69 0 3.29-.42 4.7-1.14M83.16 58.17c-1.44-.42-2.94-.66-4.49-.66-6.93 0-12.89 4.1-15.6 10.01-.25.54.18 1.16.78 1.16l16.6-.09c1.6-3.15 2.56-6.68 2.71-10.43zM32.59 56.47c1.36.66 2.88 1.05 4.49 1.05 5.67 0 10.27-4.6 10.27-10.27 0-4.12-2.43-7.66-5.93-9.3-5.25 4.5-8.64 11.11-8.84 18.53z"
    />
    <path
      fill="#8F9BA8"
      d="M37.29 57.51c-1.63 0-3.2.23-4.69.66.15 3.75 1.11 7.29 2.72 10.45l16.72-.09c.64 0 1.02-.68.73-1.25-2.89-5.56-8.85-9.77-15.47-9.77z"
    />
    <path
      fill="#7B8493"
      d="M57.78 68.65c5.838 0 10.57-4.733 10.57-10.57s-4.732-10.57-10.57-10.57-10.57 4.732-10.57 10.57c0 5.837 4.732 10.57 10.57 10.57"
    />
    <path
      fill="#7B8493"
      d="M42.73 77.43c4.22 3.16 9.47 5.03 15.15 5.03s11-1.9 15.24-5.11c-3.18-5.04-8.87-8.72-15.14-8.72s-12.2 3.54-15.26 8.79z"
    />
    <path
      fill="#C7D0D9"
      d="M86.77 31.35c-2.43 0-4.61 1.03-6.15 2.67 3.87 3.8 6.8 8.56 8.38 13.91 3.58-.98 6.21-4.25 6.21-8.13 0-4.66-3.78-8.44-8.44-8.44zM99.65 56.26c-2.05-3.94-5.97-7.05-10.5-7.83.78 2.78 1.2 5.7 1.2 8.73v.17l8.71-.05c.52 0 .84-.56.6-1.02zM35.11 34.15a8.4 8.4 0 0 0-6.26-2.79c-4.66 0-8.44 3.78-8.44 8.44 0 3.97 2.74 7.29 6.44 8.19a32.35 32.35 0 0 1 8.26-13.84M25.52 57.16c0-3.03.42-5.95 1.2-8.73-4.69.77-8.6 3.85-10.53 8.03-.21.45.15.96.64.95l8.69-.05v-.21z"
    />
  </svg>
);
const SvgEnrichedIconLeadOpportunitiesGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconLeadOpportunitiesGreyscale);
export default Memo;
